import type { ReactNode } from 'react';
import type { ToastVariant } from './toastTypes';

/**
 * Variant styles
 */
export const variantStyles: Record<ToastVariant, { icon: ReactNode; colors: string }> = {
  success: {
    icon: (
      <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
      </svg>
    ),
    colors: 'border-success/30 text-success bg-success/10',
  },
  error: {
    icon: (
      <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
      </svg>
    ),
    colors: 'border-error/30 text-error bg-error/10',
  },
  warning: {
    icon: (
      <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
        />
      </svg>
    ),
    colors: 'border-warning/30 text-warning bg-warning/10',
  },
  info: {
    icon: (
      <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
        />
      </svg>
    ),
    colors: 'border-primary/30 text-primary bg-primary/10',
  },
};

/**
 * Farbe der Restlaufzeitleiste.
 *
 * Sie leitet sich aus der Rahmenfarbe der Variante ab: die erste Klasse des
 * Farbsatzes (`border-…`) wird zur Hintergrundklasse (`bg-…`) umgeschrieben.
 */
export const getDurationBarClass = (colors: string): string | undefined =>
  colors.split(' ')[0]?.replace('border-', 'bg-');
